export const newWindowProps = {
  width: '1100',
  height: '756',
  location: 'yes',
  menubar: 'no',
  toolbar: 'no',
};

export const openInNewWindow = (url: string) => {
  const stringProps = Object.entries(newWindowProps)
    .map(([prop, value]) => `${prop}=${value}`)
    .join();

  window.open(url, '_blank', stringProps);
};
